const cachedScripts: string[] = [];

export default function scriptLoader(
  src: string,
  {
    scriptText,
    HTMLAttributes,
    async,
    crossOrigin,
  }: {
    scriptText?: string;
    HTMLAttributes?: { [key: string]: any };
    async: boolean;
    crossOrigin?: 'anonymous' | 'use-credentials';
  } = {
    async: true,
  }
): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    if (cachedScripts.includes(src)) {
      return resolve();
    }

    const script = document.createElement('script');

    script.onload = function onLoad() {
      resolve();
    };
    script.onerror = reject;

    if (async) script.async = true;

    if (src) script.src = src;

    if (crossOrigin) script.crossOrigin = crossOrigin;

    if (scriptText) {
      const text = document.createTextNode(scriptText);
      script.appendChild(text);
    }

    if (HTMLAttributes) {
      for (const key of Object.keys(HTMLAttributes)) {
        script.setAttribute(key, HTMLAttributes[key]);
      }
    }

    if (document.currentScript) {
      document.currentScript.parentNode.insertBefore(
        script,
        document.currentScript
      );
    } else {
      (document.head || document.getElementsByTagName('head')[0]).appendChild(
        script
      );
    }
    cachedScripts.push(src);
  });
}
